module.exports = __webpack_public_path__ + "static/media/icon-how-it-works8.93e7ba0a.svg";